module.exports = __webpack_public_path__ + "img/C06TechBowmanChampion_ua.b19947ce.webp";